import React, { useState } from "react";
import { useParams } from "react-router";

import JikeiTeamDetail from "./JikeiTeamDetail";

import { useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";

import { RequestState } from "../../../../utils/RequestState";
import {
  useGetTeamsAdmin,
  useUpdateTeamAdmin,
} from "../../../../utils/useTeam";

const JikeiTeamDetailContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const [selectStatus, setSelectStatus] = useState<string>();
  const [showStatusMenu, setShowStatusMenu] = useState<boolean>(false);
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  const handleStatusMenu = () => {
    setShowStatusMenu(!showStatusMenu);
  };

  const auth_token = useAppSelector(getAuthToken);

  const queryKey = {
    auth_token,
    id,
    is_jikei_request: true,
  };

  const {
    items: { teams, owners },
    isLoading,
  } = useGetTeamsAdmin(queryKey);

  const team = teams[0];
  const owner = owners[0];

  const { mutateAsync, mutateLoading } = useUpdateTeamAdmin(["teamAdmin", queryKey]);

  const handleUpdate = async () => {
    if (auth_token && id && selectStatus !== undefined) {
      setRequestState(RequestState.Doing);

      const update_args: { [key: string]: string } = {};
      update_args["sonic_status"] = selectStatus;

      await mutateAsync({
        auth_token: auth_token,
        id: id,
        update: update_args,
        is_jikei_request: true,
      });

      setRequestState(RequestState.Success);
      setShowStatusMenu(false);
      setSelectStatus("");
    }
  };

  return (
    <JikeiTeamDetail
      team={team}
      owner={owner}
      isLoading={isLoading || mutateLoading}
      selectStatus={selectStatus}
      setSelectStatus={setSelectStatus}
      handleUpdate={handleUpdate}
      showStatusMenu={showStatusMenu}
      handleStatusMenu={handleStatusMenu}
      requestState={requestState}
    />
  );
};

export default JikeiTeamDetailContainer;
